import type { QuoteErrors, QuoteValues, RequiredQuoteField } from '../types/quote';

export const requiredQuoteFields: RequiredQuoteField[] = ['name', 'phone', 'email'];

export function isRequiredQuoteField(name: string): name is RequiredQuoteField {
  return (requiredQuoteFields as string[]).includes(name);
}

export function validateQuoteField(name: RequiredQuoteField, value: string): string | undefined {
  const v = value.trim();
  if (name === 'name') return v ? undefined : 'Enter your name.';
  if (name === 'phone') {
    if (!v) return 'Enter a phone number.';
    return v.replace(/\D/g, '').length >= 10 ? undefined : 'Enter a phone number with area code.';
  }
  if (!v) return 'Enter an email address.';
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? undefined : 'Enter a valid email address, like name@company.com.';
}

export function validateQuote(values: QuoteValues): QuoteErrors {
  const errors: QuoteErrors = {};
  requiredQuoteFields.forEach((field) => {
    const message = validateQuoteField(field, values[field]);
    if (message) errors[field] = message;
  });
  return errors;
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
